module.exports = __webpack_public_path__ + "img/cup.f1114210.svg";